<div class="container-fluid m-0 banner p-0"  [style.background-image]="'url(' + (selectedMandate?.image | imageUrl) + ')'">
    <div [style.background-color]="community?.color1 ? convertHexToRgba(community.color1 , 0.5): convertHexToRgba('#17A1FA', 0.5)" class="w-100 py-3 m-0">
        <div class="container">
            <h1 *ngIf="selectedMandate" class="text-white text-center py-4" style="font-weight: 700">{{'PAM.bannerTitle' | translate}} <br>
                {{selectedMandate.nameSelector}}</h1>
            <p-skeleton  *ngIf="!selectedMandate" styleClass="mb-2"  height="120px"></p-skeleton>
        </div>
    </div>
</div>
